import { useEffect, useState } from 'react';

interface CameraFlashProps {
  trigger: boolean;
  onComplete?: () => void;
}

export function CameraFlash({ trigger, onComplete }: CameraFlashProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (trigger) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        onComplete?.();
      }, 350);
      return () => clearTimeout(timer);
    }
  }, [trigger, onComplete]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-white animate-flash pointer-events-none" />
  );
}
